import { Controller } from 'stimulus';

class HeaderController extends Controller {
  connect() {
    this.direction = 'down';
    this.delta = 0;
    this.previousScrollY = 0;
    this.isVisible = true;
  }

  onWindowScroll() {
    const { scrollY } = window;
    const newDirection = this.previousScrollY < scrollY ? 'down' : 'up';

    // At the top of the page, always show the header.
    if (scrollY < 250) {
      this.toggleHeader(true);
      return;
    }

    // If the direction has changed, we set the delta back to 0.
    if (newDirection !== this.direction) {
      this.direction = newDirection;
      this.delta = 0;
    }

    const diff = Math.abs(this.previousScrollY - scrollY);

    this.delta += diff;

    if (this.direction === 'down' && this.delta > 50) {
      this.toggleHeader(false);
    } else if (this.direction === 'up' && this.delta > 50) {
      this.toggleHeader(true);
    }

    this.previousScrollY = scrollY;
  }

  toggleHeader(state) {
    if (state && !this.isVisible) {
      this.isVisible = true;
      this.element.classList.remove('is-hidden');
    } else if (!state && this.isVisible) {
      this.isVisible = false;
      this.element.classList.add('is-hidden');
    }
  }
}

HeaderController.targets = [];

export default HeaderController;
